import { stories } from "@/mocks/stories";
import StoryRow from "./StoryRow";

export default function DuoSection() {
  const desk = stories.filter((s) => s.category === "desk");
  const chat = stories.filter((s) => s.category === "chat");

  return (
    <section id="duo" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
          <i className="ri-community-line" /> 同桌 &amp; 班级群聊
        </span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
          同桌很离谱，群聊更离谱
        </h2>
        <p className="mt-2 text-sm text-foreground-600 md:text-base">
          校园同桌奇葩事 + 班级群聊翻车合集，两边的瓜一个都不许错过。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
        <div>
          <div className="mb-3 flex items-center gap-2 px-1">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-secondary-500 text-lg text-white">
              🪑
            </span>
            <h3 className="font-heading text-xl text-foreground-900">校园同桌奇葩事</h3>
            <span className="ml-auto text-xs text-foreground-400">{desk.length} 则</span>
          </div>
          <div className="flex flex-col gap-4">
            {desk.map((s) => (
              <StoryRow key={s.id} story={s} />
            ))}
          </div>
        </div>

        <div>
          <div className="mb-3 flex items-center gap-2 px-1">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-foreground-800 text-lg text-white">
              📱
            </span>
            <h3 className="font-heading text-xl text-foreground-900">班级群聊翻车合集</h3>
            <span className="ml-auto text-xs text-foreground-400">{chat.length} 则</span>
          </div>
          <div className="flex flex-col gap-4">
            {chat.map((s) => (
              <StoryRow key={s.id} story={s} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}